module.exports = __webpack_public_path__ + "static/media/final_target.2af56baf.png";